import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
  Chip,
  Stack,
  Paper,
  Grid,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  getInterviewRounds,
  updateAssignment,
} from "../../../../Redux/Reducers/JobReducer"; // Import your submit action
import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import AssignmentModal from "./AssignmentModal";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";

const ApplicantInterviewRounds = ({ open, onClose, candidateId }) => {
  console.log("candidateIdNNNNNN", candidateId);
  const dispatch = useDispatch();
  const [rounds, setRounds] = useState([]);
  const [openPdf, setPdfOpen] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState("");
  const [submissionData, setSubmissionData] = useState({});
  const [viewType, setViewType] = useState("");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const InterviewRoundsRes = useSelector(
    (state) => state?.jobs?.interviewRounds
  );

  console.log("InterviewRoundsRes123", InterviewRoundsRes)

  useEffect(() => {
    if (candidateId) {
      dispatch(getInterviewRounds(candidateId));
    }
  }, [candidateId, dispatch]);

  useEffect(() => {
    if (InterviewRoundsRes?.length) {
      setRounds(InterviewRoundsRes);
      // Initialize submission data for each assignment round
      const initialData = {};
      InterviewRoundsRes.forEach((round) => {
        if (round.type === "Assignment") {
          initialData[round.round_code] = {
            attachment: null,
            submission_link: "",
            application_id: round.application_id,
          };
        }
      });
      setSubmissionData(initialData);
    }
  }, [InterviewRoundsRes]);

  const handleViewDoc = (round, type) => {

      if (round?.assignment_file_type && 
      !(round.assignment_file_type === "application/pdf" || 
        round.assignment_file_type.startsWith("image/"))) {
    // Direct navigation for non-PDF/image files
    window.open(round.assignment_file, '_blank');
    return;
  }

  
    setSelectedAssignment(round);
    setViewType(type);
    setPdfOpen(true);
  };

  const handleCloseModal = () => {
    setPdfOpen(false);
  };

  const handleFileUpload = (roundCode, e) => {
    const file = e.target.files[0];
    console.log("AWWWW",file, roundCode)
    setSubmissionData((prev) => ({
      ...prev,
      [roundCode]: {
        ...prev[roundCode],
        attachment: file,
        submission_link: "",
      },
    }));
  };

  const handleRemoveFile = (roundCode) => {
    setSubmissionData((prev) => ({
      ...prev,
      [roundCode]: {
        ...prev[roundCode],
        attachment: null,
      },
    }));
  };

  const handleLinkChange = (roundCode, value) => {
    setSubmissionData((prev) => ({
      ...prev,
      [roundCode]: {
        ...prev[roundCode],
        submission_link: value,
        attachment: null,
      },
    }));
  };

  const handleSubmit = (round) => {
    const roundData = submissionData[round.round_code];

    const payload = {
      application_id: roundData.application_id,
      round_code: round.round_code,
    };

    if (roundData.attachment) {
      payload.attachment = roundData.attachment;
    } else {
      payload.submission_link = roundData.submission_link;
    }

    console.log("PayloadPayload", payload);

    dispatch(updateAssignment(payload)).then(() => {
      // Refresh rounds data after submission
      dispatch(getInterviewRounds(candidateId));
      // Clear submission data for this round
      setSubmissionData((prev) => ({
        ...prev,
        [round.round_code]: {
          ...prev[round.round_code],
          attachment: null,
          submission_link: "",
        },
      }));
    });
  };

  const RoundCard = ({ round }) => {
    const currentTime = new Date();
    const deadline = new Date(round?.deadline);
    const isDeadlinePassed = currentTime > deadline;

    return (
      <Box
        sx={{
          mb: 2,
          p: 2,
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          backgroundColor: round?.scheduled ? "#E3F2FD" : "#f5f5f5",
        }}
      >
        {/* ... (keep existing header and other round types) */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" color="#0044C6">
            {round?.name}
          </Typography>
          {round?.selection_status && (
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: round?.selection_status === "Selected" ? "green" : "red",
              }}
            >
              {round?.selection_status}
            </Typography>
          )}
        </Box>

        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Type: {round.type === "F2F" ? "Face to Face" : round.type}
        </Typography>

        {round.type === "F2F" && round?.interview_schedule && (
          <>
            <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
              Date:{" "}
              {new Date(
                round?.interview_schedule?.start_time
              ).toLocaleDateString()}
            </Typography>
            <Typography variant="body2" sx={{ color: "#666" }}>
              Time:{" "}
              {new Date(
                round?.interview_schedule?.start_time
              ).toLocaleTimeString()}{" "}
              -
              {new Date(
                round?.interview_schedule?.end_time
              ).toLocaleTimeString()}
            </Typography>
            <Button
              variant="text"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                round?.interview_location
              )}`}
              target="_blank"
              sx={{ textTransform: "none" }}
              startIcon={<LocationOnRoundedIcon />}
            >
              {round?.interview_location}
            </Button>
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                mt: 0.5,
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: showFullDescription ? "unset" : 2,
                WebkitBoxOrient: "vertical",
                whiteSpace: showFullDescription ? "pre-line" : "normal",
                transition: "all 0.2s",
              }}
            >
              Description: {round?.description}
            </Typography>
            {round?.description && round?.description.length > 80 && (
              <Button
                variant="text"
                size="small"
                sx={{ p: 0, minWidth: "auto", textTransform: "none" }}
                onClick={() => setShowFullDescription((prev) => !prev)}
              >
                {showFullDescription ? "See less" : "See more"}
              </Button>
            )}

            {/* Interviewer Details for F2F */}
            {round?.interviewers_list && (
              <Box sx={{ mt: 2, borderTop: "1px solid #eee", pt: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
                >
                  Interviewer Details:
                </Typography>
                {round?.interviewers_list?.map((interviewer, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                      p: 1,
                      borderRadius: "4px",
                      backgroundColor: "rgba(0, 68, 198, 0.05)",
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        interviewer?.profile_url ||
                        "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                      }
                      alt={`${interviewer?.first_name}'s profile`}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {interviewer?.first_name || "User"}{" "}
                        {interviewer?.last_name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#666" }}>
                        {interviewer?.email}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </>
        )}

        {round.type === "Remote" && round?.interview_schedule && (
          <>
            <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
              Date:{" "}
              {new Date(
                round?.interview_schedule?.start_time
              ).toLocaleDateString()}
            </Typography>
            <Typography variant="body2" sx={{ color: "#666" }}>
              Time:{" "}
              {new Date(
                round?.interview_schedule?.start_time
              ).toLocaleTimeString()}{" "}
              -
              {new Date(
                round?.interview_schedule?.end_time
              ).toLocaleTimeString()}
            </Typography>

            {/* Interviewer Details for Remote */}
            {round?.interviewers_list && (
              <Box sx={{ mt: 2, mb: 2, borderTop: "1px solid #eee", pt: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
                >
                  Interviewer Details:
                </Typography>
                {round?.interviewers_list?.map((interviewer, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                      p: 1,
                      borderRadius: "4px",
                      backgroundColor: "rgba(0, 68, 198, 0.05)",
                    }}
                  >
                    <Box
                      component="img"
                      src={
                        interviewer?.profile_url ||
                        "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                      }
                      alt={`${interviewer?.first_name}'s profile`}
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {interviewer?.first_name || "User"}{" "}
                        {interviewer?.last_name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#666" }}>
                        {interviewer?.email}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            <Button
              variant="contained"
              color="primary"
              href={round?.interview_schedule?.meet_link}
              target="_blank"
              sx={{
                mt: 1,
                alignItems: "center",
                cursor: "pointer",
                textTransform: "none",
                backgroundColor: "#0044C6",
                "&:hover": { backgroundColor: "#003399" },
                pointerEvents: "auto",
              }}
            >
              <span style={{ marginRight: "5px" }}>
                <InsertLinkRoundedIcon />
              </span>{" "}
              Join Meeting
            </Button>
          </>
        )}

        {round.type === "Assignment" && (
          <>
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  Assignment Details
                </Typography>
                <Chip
                  label={isDeadlinePassed ? "Submission Closed" : "Active"}
                  color={isDeadlinePassed ? "error" : "success"}
                  size="small"
                />
              </Stack>

              <Typography variant="body2" sx={{ mt: 1, color: "#6c757d" }}>
                Deadline: {new Date(round?.deadline).toLocaleString()}
              </Typography>

              <Button
                variant="outlined"
                startIcon={<AssignmentRoundedIcon />}
                onClick={() => handleViewDoc(round, "Assignment")}
                sx={{ mt: 1, mb: 2 }}
              >
                {round.assignment_file_type === "application/pdf" || 
         round.assignment_file_type?.startsWith("image/") 
          ? "View Assignment Brief"
          : "Download Assignment"}
              </Button>

              {!isDeadlinePassed &&  !round?.submission_file && (
                <Box sx={{ borderTop: "1px solid #dee2e6", pt: 2 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ fontWeight: 600, color: "#2c3e50" }}
                  >
                    Submit Your Work
                  </Typography>

                  {/* Link Submission Section */}
                  {!submissionData[round.round_code]?.attachment  && (
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Paste submission link here"
                        value={
                          submissionData[round.round_code]?.submission_link ||
                          ""
                        }
                        onChange={(e) =>
                          handleLinkChange(round.round_code, e.target.value)
                        }
                        InputProps={{
                          endAdornment: submissionData[round.round_code]
                            ?.submission_link && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleLinkChange(round.round_code, "")
                              }
                              sx={{ color: "#6c757d" }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          ),
                        }}
                      />
                    </Box>
                  )}

                  {/* File Upload Section */}
                  {!submissionData[round.round_code]?.submission_link && (
                    <Box sx={{ mb: 2 }}>
                      {submissionData[round.round_code]?.attachment ? (
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Chip
                            label={
                              submissionData[round.round_code].attachment.name
                            }
                            onDelete={() => handleRemoveFile(round.round_code)}
                            deleteIcon={
                              <CloseIcon style={{ fontSize: "16px" }} />
                            }
                            variant="outlined"
                            sx={{ borderRadius: "4px" }}
                          />
                        </Stack>
                      ) : (
                        <>
                          <input
                            accept="*"
                            style={{ display: "none" }}
                            id={`file-upload-${round.round_code}`}
                            type="file"
                            onChange={(e) =>
                              handleFileUpload(round.round_code, e)
                              
                            }
                          />
                          <label htmlFor={`file-upload-${round.round_code}`}>
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={<UploadFileIcon />}
                              sx={{ mr: 2 }}
                            >
                              Upload File
                            </Button>
                          </label>
                          <Typography variant="caption" color="textSecondary">
                            (Max size: 25MB, ZIP format only)
                          </Typography>
                        </>
                      )}
                    </Box>
                  )}

                  {/* Divider */}
                  {!submissionData[round.round_code]?.attachment &&
                    !submissionData[round.round_code]?.submission_link && (
                      <Box sx={{ my: 2, position: "relative" }}>
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            width: "100%",
                            borderBottom: "1px solid #dee2e6",
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            position: "relative",
                            display: "block",
                            width: "fit-content",
                            mx: "auto",
                            px: 1,
                            backgroundColor: "#f8f9fa",
                            color: "#6c757d",
                          }}
                        >
                          OR
                        </Typography>
                      </Box>
                    )}
                     

                  {/* Submit Button */}
                  <Button
                    variant="contained"
                    color="primary"
                    // disabled={
                    //   !submissionData[round.round_code]?.attachment &&
                    //   !submissionData[round.round_code]?.assignment_link
                    // }
                    onClick={() => handleSubmit(round)}
                    sx={{
                      mt: 2,
                      px: 4,
                      borderRadius: "6px",
                      textTransform: "none",
                      fontWeight: 600,
                      boxShadow: "none",
                      "&:hover": { boxShadow: "0 2px 6px rgba(0,0,0,0.2)" },
                    }}
                  >
                    {submissionData[round.round_code]?.attachment
                      ? "Submit File"
                      : "Submit Link"}
                  </Button>
                </Box>
              )}
             {/* {round?.submission_file ? (
  <Box sx={{ mt: 2 }}>
  <Grid container direction="column" spacing={1} alignItems="left">
    <Grid item>
      <Chip label="Assignment submitted" color="primary" />
    </Grid>
    <Grid item>
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleViewDoc(round, "submission")}
      >
        View Submission
      </Button>
    </Grid>
  </Grid>
</Box>

) : (
  ""
)} */}
{round?.submission_file &&
        (round?.submission_file_type === "application/pdf" ||
        round?.submission_file_type?.startsWith("image/") ? (
          <Typography
            component="a"
            href={round?.submission_file}
            onClick={(e) => {
              e.preventDefault();
              handleViewDoc(round, "submission");
            }}
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            View Submission
          </Typography>
        ) : (
          <Typography
            component="a"
            href={round?.submission_file}
            target="_blank"
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            <AssignmentRoundedIcon
              sx={{ color: "#0044C6", marginRight: "5px" }}
            />
            Download Assignment
          </Typography>
        ))}
            </Box>
          </>
        )}
      </Box>
    );
  };

  return (
    <Paper
      sx={{
        height: "80vh",
        maxHeight: "90vh",
        overflowY: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <Box sx={{ p: 3 }}>
        {/* <Typography variant="h6" fontWeight="bold" mb={2}>
        Your Interview Rounds
      </Typography> */}
       
        {rounds?.length > 0 ? (
          rounds.map((round, index) => <RoundCard key={index} round={round} />)
        ) : (
          <Typography>No interview rounds scheduled yet.</Typography>
        )}

        <AssignmentModal
          viewType={viewType}
          openPdf={openPdf}
          onClose={handleCloseModal}
          application_id={selectedAssignment?.application_id}
          assignment_file={selectedAssignment?.assignment_file}
          assignment_file_type={selectedAssignment?.assignment_file_type}
          submission_file={selectedAssignment?.submission_file}
          submission_file_type={selectedAssignment?.submission_file_type}
        />
      </Box>
    </Paper>
  );
};

export default ApplicantInterviewRounds;
